<div class="row principalDarkerBackground centrado fullHeight">
    <div class="card width90 ">
        <div class="card-container">
            <div class="row centrado">
                <div [formGroup]="companyForm" >
                    <div class="col-md-12 padding50">
                        <img src="assets/images/logo.png" class="imgLogoMed">
                    </div>

                    <div class="col-md-12 slide-in-top padding50">
                        <label>
                            <input type="text" numbersOnly maxlength="9"
                                   formControlName="rut" class="form-control" placeholder="Ingrese Cédula"
                                   >
                        </label>
                    </div>
                </div>
                <div class="col-md-12 centrado padding50">
                    <div class="col-md-3"></div>
                    <div class="col-md-4 col-sm-6">
                        <a class="nav-link botonID principalBackground padding10" (click)="onConfirmClick(companyForm)">
                            OK  </a>
                    </div>
                    <div class="col-md-3"></div>
                </div>
            </div>
        </div>

    </div>
</div>
